
    const data = {"name":"src/core/icons/swap-horizontal-circle","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M22 12c0-5.5-4.5-10-10-10S2 6.5 2 12s4.5 10 10 10 10-4.5 10-10m-7-5.5 3.5 3.5-3.5 3.5V11h-4V9h4V6.5m-6 11L5.5 14 9 10.5V13h4v2H9v2.5Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            